<template>
  <div>
    <v-toolbar class="my-md-auto nobackground" elevation="0"  >
      <v-toolbar-title  v-if="item" class="toolbartitle_50" >
        <h1><v-icon large>mdi-file-cad</v-icon>
          <span class="" v-if="language == 'fr'">{{ item['namefr'] }}</span>
          <span class="" v-else>{{ item['name'] }}</span>
        </h1>
      </v-toolbar-title>
      <v-spacer />
      <v-btn
        v-if="userHasAccess('designfile_edit')"
        class="ml-2 textresponsive"
        color="primary"
        :to="{ name: 'DesignFileUpdate' }"
      >
        {{ $t('global.update')}}
      </v-btn>
      <v-btn
        v-if="item['file']"
        class="ml-sm-2 textresponsive"
        color="primary"
        @click="downloadFile(customname)"
      >
      <v-icon
       class="mr-2"
        right
        dark
      >mdi-download
      </v-icon>
        {{ $t('global.download')}}
      </v-btn>
    </v-toolbar>
    <div v-if="item" class="table-designfile-show">
      <v-row class="ml-0 mr-0">
        <v-col md="4">
          <STLView
            class="pl-4"
            ref="viewSTL"
            :item="item"
            bigfile
            v-if="item['file']"

          />
        </v-col>
        <v-col md="8" >
          <v-row class="ml-4 mr-4" v-if="userHasAccess('designfile_edit')">
            <v-col >
              <v-row>
                <v-col md="3" >
                  <span class="ml-4 primary--text">{{ $t('global.name') }}</span>
                </v-col>
                <v-col md="9">
                  <strong class="mr-2">{{ item['name'] }}</strong>
                </v-col>
              </v-row>
              <v-divider class="primary"></v-divider>
            </v-col>
          </v-row>
          <v-row class="ml-4 mr-4" v-if="userHasAccess('designfile_edit')">
            <v-col >
              <v-row>
                <v-col md="3" >
                  <span class="ml-4 primary--text">{{ $t('global.namefr') }}</span>
                </v-col>
                <v-col md="9">
                  <strong class="mr-2">{{ item['namefr'] }}</strong>
                </v-col>
              </v-row>
              <v-divider class="primary"></v-divider>
            </v-col>
          </v-row>
          <v-row class="ml-4 mr-4" v-else>
            <v-col >
              <v-row>
                <v-col md="3" >
                  <span class="ml-4 primary--text">{{ $t('global.name') }}</span>
                </v-col>
                <v-col md="9">
                  <strong class="mr-2" v-if="language == 'fr'">{{ item['namefr'] }}</strong>
                  <strong class="mr-2" v-else>{{ item['name'] }}</strong>
                </v-col>
              </v-row>
              <v-divider class="primary"></v-divider>
            </v-col>
          </v-row>
          <v-row class="ml-4 mr-4">
            <v-col>
              <v-row>
                <v-col md="3" >
                  <span class="ml-4 primary--text">{{ $t('designfile.type') }}</span>
                </v-col>
                <v-col md="9">
                  <strong class="mr-2" v-if="item['type']" >
                    <span  v-if="language == 'fr'"> {{ item['type'].namefr }}</span>
                    <span  v-else> {{ item['type'].name }}</span>
                  </strong>
                </v-col>
              </v-row>
              <v-divider class="primary"></v-divider>
            </v-col>
          </v-row>
          <v-row class="ml-4 mr-4">
            <v-col >
              <v-row>
                <v-col md="3" >
                  <span class="ml-4 primary--text">{{ $t('designfile.author') }}</span>
                </v-col>
                <v-col md="9">
                  <strong class="mr-2">{{ item['author'] }}</strong>
                </v-col>
              </v-row>
              <v-divider class="primary"></v-divider>
            </v-col>
          </v-row>
          <v-row class="ml-4 mr-4">
            <v-col >
              <v-row>
                <v-col md="3" >
                  <span class="ml-4 primary--text">{{ $t('designfile.license') }}</span>
                </v-col>
                <v-col md="9">
                  <strong class="mr-2">{{ item['license'] }}</strong>
                </v-col>
              </v-row>
              <v-divider class="primary"></v-divider>
            </v-col>
          </v-row>
          <v-row class="ml-4 mr-4" v-if="userHasAccess('designfile_edit')">
            <v-col >
              <v-row>
                <v-col md="3" >
                  <span class="ml-4 primary--text">{{ $t('designfile.description') }}</span>
                </v-col>
                <v-col md="9">
                  <strong class="mr-2">{{ item['description'] }}</strong>
                </v-col>
              </v-row>
              <v-divider class="primary"></v-divider>
            </v-col>
          </v-row>
          <v-row class="ml-4 mr-4" v-if="userHasAccess('designfile_edit')">
            <v-col >
              <v-row>
                <v-col md="3" >
                  <span class="ml-4 primary--text">{{ $t('designfile.descriptionfr') }}</span>
                </v-col>
                <v-col md="9">
                  <strong class="mr-2">{{ item['descriptionfr'] }}</strong>
                </v-col>
              </v-row>
              <v-divider class="primary"></v-divider>
            </v-col>
          </v-row>
          <v-row class="ml-4 mr-4" v-else>
            <v-col >
              <v-row>
                <v-col md="3" >
                  <span class="ml-4 primary--text">{{ $t('designfile.description') }}</span>
                </v-col>
                <v-col md="9">
                  <strong class="mr-2" v-if="language == 'fr'">{{ item['descriptionfr'] }}</strong>
                  <strong class="mr-2" v-else>{{ item['description'] }}</strong>
                </v-col>
              </v-row>
              <v-divider class="primary"></v-divider>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </div>

    <Loading :visible="isLoading" />
  </div>
</template>

<script>
import i18n from '../../i18n.js';
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import Loading from '../../components/Loading';
import ShowMixin from '../../mixins/ShowMixin';
import AccessMixin from '../../mixins/AccessMixin';
import FileMixin from '../../mixins/FileMixin';
import STLView from '../../components/STLView.vue';

const servicePrefix = 'DesignFile';

export default {
  name: 'DesignFileShow',
  servicePrefix,
  components: {
      Loading,
      STLView,
  },
  data() {
    return {
    };
  },

  mixins: [ShowMixin,AccessMixin,FileMixin],
  computed: {
    ...mapFields('designfile', {
      isLoading: 'isLoading'
    }),
    ...mapGetters('designfile', ['find']),
    language() {
      return i18n.locale;
    },
    customname() {
      if( this.item) {
        return this.item.name +'_'+ this.item.license;
      } else {
        return '';
      }

    }
  },
  methods: {
    ...mapActions('designfile', {
      deleteItem: 'del',
      reset: 'reset',
      retrieve: 'load'
    }),

  },
};
</script>
